import { createContext } from '@change-corgi/core-react/context';

export const {
	Context: AppRenderContext,
	Provider: AppRenderContextProvider,
	useContext: useAppRenderContext,
} = createContext<{ firstRender: boolean } | undefined>(undefined, {
	name: 'AppRenderContext',
});
